import { css } from "@linaria/core"
import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"

import { Horizontal, Vertical } from "@/components/Flex.ts"
import { smallerFontSize } from "@/styles/textStyles.ts"

export const SettingsDialogStyles = {
  Title: styled.div`
  `,

  Layout: styled(Horizontal)`
    margin: 0 -24px -24px;
    border-top: 1px solid var(--separator-color);
  `,

  Sidebar: styled(Vertical)`
    flex-shrink: 0;

    width: 200px;
    height: 600px;
    max-height: 50vh;
  `,

  SidebarInner: css`
    display: flex;
    flex-direction: column;

    gap: 8px;
    flex-shrink: 0;

    padding: 16px 24px;
  `,

  Separator: styled.div`
    width: 1px;
    background-color: var(--separator-color);
  `,

  Content: styled(Vertical)`
    flex: 1 1 auto;

    width: 0;
    height: 600px;
    max-height: 50vh;
  `,

  ContentInner: css`
    padding: 24px;
  `,

  SidebarTitle: styled.span`
    color: var(--secondary-text-color);

    ${smallerFontSize};
  `,

  SidebarItem: styled.span<{
    active: boolean
  }>`
    color: var(--text-color);
    background: ${props => props.active ? "var(--text-color-5)" : "transparent"};

    margin: 0 -12px;
    border-radius: var(--border-radius-12);
  `,

  SidebarLink: styled(Link)`
    display: block;
    padding: 8px 12px;

    color: inherit;
  `,

  SidebarSeparator: styled.div`
    height: 1px;
    margin: 0 -24px;
    background-color: var(--separator-color);
  `
}